import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useCreateUnitMutation } from "../../core/redux/api/productApi";

const unitSchema = Yup.object().shape({
  unitName: Yup.string().required("Unit Name is required"),
  shortName: Yup.string().required("Unit's Short Name is required"),
});

const AddUnitModal = ({ show, onClose, onSave }) => {
  const [addUnit] = useCreateUnitMutation();
  
  const formik = useFormik({
    initialValues: {
      unitName: "",
      shortName: "",
    },
    validationSchema: unitSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const promise = addUnit(values).unwrap();
        
        await toast.promise(promise, {
          loading: 'Adding new Unit...',
          success: () => {
            onSave?.(); // Use onSave instead of undefined onSuccess
            resetForm();
            onClose?.(); // Close modal after success
            return 'New Unit added!';
          },
          error: (error) => {
            console.error('Error:', error.data || error);
            return error.data?.message || 'Something went wrong while adding the Unit.';
          }
        });
      } finally {
        setSubmitting(false);
      }
    }
  });

  useEffect(() => {
    formik.resetForm();
  }, []);

  return (
    <div className="modal fade" id="add-units">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header">
                <div className="page-title">
                  <h4>Add Unit</h4>
                </div>
                <button
                  type="button"
                  className="close bg-danger text-white fs-16"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    formik.resetForm();
                    onClose?.();
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">
                      Unit<span className="text-danger ms-1">*</span>
                    </label>
                    <input
                      name="unitName"
                      type="text"
                      className={`form-control ${formik.touched.unitName && formik.errors.unitName ? 'is-invalid' : ''}`}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.unitName}
                    />
                    {formik.touched.unitName && formik.errors.unitName && (
                      <div className="invalid-feedback">{formik.errors.unitName}</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Short Name<span className="text-danger ms-1">*</span>
                    </label>
                    <input
                      name="shortName"
                      type="text"
                      className={`form-control ${formik.touched.shortName && formik.errors.shortName ? 'is-invalid' : ''}`}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.shortName}
                    />
                    {formik.touched.shortName && formik.errors.shortName && (
                      <div className="invalid-feedback">{formik.errors.shortName}</div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                      onClick={() => {
                        formik.resetForm();
                        onClose?.();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary fs-13 fw-medium p-2 px-3"
                      disabled={formik.isSubmitting}
                    >
                      {formik.isSubmitting ? 'Adding...' : 'Add Unit'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUnitModal;